<template>
  <div>
    <div class="udfDetails">
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />

      <div class="authField">
        <tl-checkbox
          class="grpCheckboxes"
          name="twoFactorBox"
          label="Enable 2 Factor Authentication"
          v-model="formData.enableTwoFactor"
          ref="twoFactorCheckbox"
          data-vv-as="enable 2 factor"
        />
      </div>
      <div v-if="formData.enableTwoFactor" class="margintop-24">
        <div>
          <tl-select
            name="otpSelection"
            label="Send OTP To *"
            labelText="name"
            :options="otpTypeList"
            v-model="formData.otpType"
            @change="(val) => changeOTPtype(val)"
            data-vv-as="send OTP to"
            v-validate="'required_if:twoFactorCheckbox,true'"
            :classname="errors.has('otpSelection')"
          ></tl-select>
          <span v-if="errors.has('otpSelection')" class="errorMessage">
            <span class="error">Send OTP to field is required</span>
          </span>
        </div>
        <div>
          <div class="otpLabel">
            <span class>OTP Expiration Time *</span>
          </div>
          <div class="otpLabelFields">
            <txt
              type="text"
              name="otpExpirationTime"
              placeholder="Value"
              v-model="formData.otpValue"
              v-numeric-only
              data-vv-as="OTP expiration time"
              v-validate="'required_if:twoFactorCheckbox,true'"
              :classname="errors.has('otpExpirationTime')"
            />
            <div class="durationLabel">
              <span>Seconds</span>
            </div>
          </div>
          <span v-if="errors.has('otpExpirationTime')" class="errorMessage">
            <span class="error">OTP expiration time field is required</span>
          </span>
        </div>
      </div>
    </div>

    <tick-animation v-if="showSuccessMsg"></tick-animation>

    <bottom-action-container class="placeAtEnd">
      <btn-skip @navClicked="$emit('skip')"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="$emit('previous')" />
          <btn text="Next" type="primary" @click="createLoginSettings()" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>


<script>
import { mapState, mapGetters, mapActions } from "vuex";
import * as constants from "@/apis/constants.js";

export default {
  data() {
    return {
      toast: false,
      formData: {
        enableTwoFactor: false,
        otpType: null,
        otpValue: "180"
      },
      otpTypeList: constants.LoginSettingsConstants.otpTypeList,
      showSuccessMsg: false,
      errmsg: ""
    };
  },
  mounted() {
    this.fetchAll();
  },
  activated() {
    this.fetchAll();
  },
  computed: {
    ...mapState({}),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    }
  },

  methods: {
    ...mapActions("onboard/loginSettings/", {
      act_fetchAll: "fetchAll",
      act_update: "update",
      act_create: "create",
      act_delete: "delete"
    }),

    /** On 'Send OTP To' dropdown value changes */
    changeOTPtype(event) {
      try {
        if (event) {
          this.formData.otpType = event;
        } else {
          this.formData.otpType = null;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /* function to hide success message and navigate to next screen / out of steppper */
    hideSuccessMsg() {
      setTimeout(() => {
        this.showSuccessMsg = false;
        this.$emit("next");
      }, 1000);
    },
    /** Function to fetch the data from server and to populate the form data */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        if (res.data) {
          if (res.data.status || res.data.statusCode) {
            let payload = res.data.payload;
            if (payload) {
              this.formData = {
                enableTwoFactor: payload.enable_2FA
                  ? payload.enable_2FA
                  : false,
                otpValue: payload.otp_expiration_time
              };
              if (payload.send_otp_to) {
                this.setOtpType(payload.send_otp_to);
              } else {
                this.formData.otpType = this.otpTypeList[2];
              }
            } else {
              this.formData.otpType = this.otpTypeList[2];
            }
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To set the 'Send OTP to' dropdown values */
    setOtpType(send_otp_to) {
      try {
        for (let i = 0; i < this.otpTypeList.length; i++) {
          let otpObj = this.otpTypeList[i];
          if (otpObj.id == send_otp_to) {
            this.formData.otpType = otpObj;
            break;
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to validate the form */
    createLoginSettings() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.create();
        }
      });
    },
    /** Function to submit the form data to server */
    async create() {
      try {
        let requestObj = {
          data: {
            le_id: this.le_id,
            enable_2FA: this.formData.enableTwoFactor,
            send_otp_to: this.formData.enableTwoFactor
              ? this.formData.otpType
                ? this.formData.otpType.id
                : null
              : "BOTH",
            otp_expiration_time: this.formData.enableTwoFactor
              ? this.formData.otpValue
              : 180
          }
        };
        this.$root._data.isSaving = true;
        let res = await this.act_create(requestObj);
        setTimeout(() => {
          if (res.data.statusCode || res.data.status) {
            this.showSuccessMsg = true;
            this.hideSuccessMsg();
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.durationLabel {
  margin-top: 8px;
  margin-left: -25px;
}
.authField {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #646464;
  margin-top: 40px;
}

.otpLabel {
  margin-top: 45px;
  span {
    font-size: 16px;
    font-weight: 600;
    color: #6e6e6e;
  }
}
.otpLabelFields {
  display: flex;
}

.errorMessage {
  color: #e01717;
  .error {
    margin-top: 5px !important;
  }
}
</style>
